import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import FormatCurrency from 'components/Common/FormatCurrency'
import { useAppSelector } from 'hooks/reduxHooks'
import { getBaseTierOfferWithJoiningFee } from 'selectors/luxPlusSelectors'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

const FinePrint = styled(BodyText)`
  opacity: 0.8;
`

// Campaign-only joining fee waiver disclaimer, spanning the full hero width below both grid
// columns. Rendered only while the campaign is active and only for visitors who can still
// purchase LuxPlus+ (this whole page context already implies that). The evergreen
// "*Based on savings..." sentence is stacked directly below it here during the campaign, so the
// standalone Footnote in LuxPlusNonMemberLandingPageContent hides itself while this is showing to
// avoid rendering the same disclaimer twice.
function LuxPlusMonthTakeoverHeroFinePrint() {
  const offer = useAppSelector(getBaseTierOfferWithJoiningFee)

  if (!offer) {
    return null
  }

  return (
    <FinePrint variant="small" colour="normal-contrast">
      <FormattedMessage
        id="17JGRxdekmyhGukCne7m"
        defaultMessage="^Joining fee currently waived when purchasing with a travel offer only. {price} annual membership renews on sign-up anniversary. Cancel renewal anytime. <link>T&Cs apply.</link>"
        description="Fine print below the LuxPlus+ Month campaign hero explaining the joining fee waiver and renewal terms"
        values={{
          price: <FormatCurrency value={offer.price} format="roundedDollar" />,
          link: (chunks) => <TextLink size="small" weight="regular" colour="inherit" to={`/${LUXURY_PLUS_PATHS.TERMS_AND_CONDITIONS_PAGE}`}>{chunks}</TextLink>,
        }}
      />
      <br />
      <FormattedMessage
        id="2Ffycma3wMHFARz-DEyO"
        defaultMessage="*Based on savings by top 10% of active LuxPlus+ members over 12 months"
        description="Footnote disclaimer about savings calculation on LuxPlus landing page"
      />
    </FinePrint>
  )
}

export default LuxPlusMonthTakeoverHeroFinePrint
